<template>
	<vxe-modal v-model="modal" width="1000" height="600" @show="show" @hdie="hide" :title="title"
		destroy-on-close :showFooter="true">
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button @click="operatetaskExport">导出</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table ref="operatetask" footer-cell-class-name="footerCellColor" :show-footer="true" border show-overflow height="450"
				:data="data">
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="name" title="运营名称">
					
				</vxe-column>
				<vxe-column field="totalscore" title="积分"></vxe-column>
			</vxe-table>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>

</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '积分统计'
				}
			},
			finishitime: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				data: [],
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
				
			},
			show() {
				this.data = []
				this.$api.operatetask.statistics({
					finishitime: this.finishitime
				}).then((res) => {
					this.data = res
					console.log(res)
				})
			},
			operatetaskExport(){
				this.$refs.operatetask.exportData({ type: 'xlsx' })
			},
			modalShow() {
				this.modal = true
			}
		},
		components: {

		}
	}
</script>
